function getFormattedTimestamp() {
  const date = new Date();
  const isoString = date.toISOString();
  const baseTime = isoString.split('.')[0];
  const timezoneOffset = -date.getTimezoneOffset();
  const sign = timezoneOffset >= 0 ? '+' : '-';
  const hours = Math.floor(Math.abs(timezoneOffset) / 60);
  const minutes = Math.abs(timezoneOffset) % 60;
  return `${baseTime}${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

function objSort(obj) {
  const sortedKeys = Object.keys(obj).sort();
  const sortedObj = {};
  sortedKeys.forEach((key) => {
    sortedObj[key] = obj[key];
  });
  return sortedObj;
}

function generateSignature(params, secret) {
  // 将参数按键排序
  const sortedParams = objSort(params);

  // 构建查询字符串
  const queryString = Object.entries(sortedParams)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  // 生成签名
  return CryptoJS.HmacSHA256(queryString, secret).toString(CryptoJS.enc.Hex);
}

function createApiRequest(params, API_KEY, API_SECRET) {
  const timestamp = Date.now().toString();

  const apiParams = {
    apiKey: API_KEY,
    timestamp: timestamp,
    ...params,
  };

  // 生成签名
  const sign = generateSignature(apiParams, API_SECRET);

  // 添加签名到参数
  apiParams.sign = sign;

  return apiParams;
}